// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ages-module__wrapper___X-Ag2"};